import React, { useState,useEffect } from 'react';
import {
    TextField,
    Select,
    MenuItem,
    Checkbox,
    FormControlLabel,
    Button,
    Typography,
    FormControl,
    FormHelperText,
    Stepper,
    Card,
    InputLabel,
    CircularProgress
} from '@material-ui/core';

// 你需要保证有可用的 dataProvider，路径依你的项目情况而定
import dataProvider from '../dataProvider';
import { QuestionAndOptions } from '../constants/business';
import SearchableSelect from '../common/SearchableSelect';
import AddressAutocomplete from '../common/AddressAutocomplete';

const validateAddress = (address) => {
    if (!address) {
        return 'Street Address is required.';
    }
    return '';
};

const validateCity = (city) => {
    if (!city) {
        return 'City is required.';
    }
    return '';
};

const validateState = (state) => {
    if (!state) {
        return 'State is required.';
    }
    return '';
};

const validatePostalCode = (postalCode) => {
    if (!postalCode) {
        return 'Postal Code is required.';
    }
    return '';
};

const validateHasPhysicalAddress = (hasAddress) => {
    if (!hasAddress) {
        return 'Please select whether you have a physical address.';
    }
    return '';
};

// 修改后的AccountCreateForm组件
const AccountCreateForm = ({ handleDialogChange, isMobile }) => {

    // 基本信息    
    const [businessType, setBusinessType] = useState(''); // 业务类型
    const [companyName, setCompanyName] = useState('');
    const [businessPhone, setBusinessPhone] = useState('')
    const [registrationNumber, setRegistrationNumber] = useState('');
    const [formationDate, setFormationDate] = useState('');
    
    // registered business address
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [stateVal, setStateVal] = useState('');
    const [stateId, setStateId] = useState('');
    const [postalCode, setPostalCode] = useState('');

    
    const [hasPhysicalAddress, setHasPhysicalAddress] = useState('');
    // physical store address
    const [physicalAddress1, setPhysicalAddress1] = useState('');
    const [physicalAddress2, setPhysicalAddress2] = useState('');
    const [physicalCity, setPhysicalCity] = useState('');
    const [physicalState, setPhysicalState] = useState('');
    const [physicalStateId, setPhysicalStateId] = useState('');
    const [physicalPostalCode, setPhysicalPostalCode] = useState('');

    // 银行账户信息
    const [bankAccountName, setBankAccountName] = useState('');
    const [bankAccountNumber, setBankAccountNumber] = useState('');
    const [bankTransitNumber, setBankTransitNumber] = useState('');
    const [bankInstitutionNumber, setBankInstitutionNumber] = useState('');
    const [bankAccountType, setBankAccountType] = useState('');

    // 添加 countrySymbol state
    const [countrySymbol, setCountrySymbol] = useState('');
    const [currency, setCurrency] = useState('');

    // 添加 states 和 cities 数据状态
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [physicalCities, setPhysicalCities] = useState([]);
    const [loadingStates, setLoadingStates] = useState(false);
    const [loadingCities, setLoadingCities] = useState(false);
    const [loadingPhysicalCities, setLoadingPhysicalCities] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [errors, setErrors] = useState({
        businessType: '',
        companyName: '',
        businessPhone: '',
        businessEIN: '',
        businessEmployeeCount: '',
        registrationNumber: '',
        formationDate: '',
        hasPhysicalAddress: '',
        businessAddress: {
            address1: '',
            address2: '',
            city: '',
            state: '',
            postalCode: '',
            country: '',
        },
        physicalAddress: {
            address1: '',
            address2: '',
            city: '',
            state: '',
            postalCode: '',
            country: '',
        },
    });

    // 获取 states 数据
    useEffect(() => {
        const fetchStates = async () => {
            setLoadingStates(true);
            try {
                const response = await dataProvider('GET_LIST', 'states', {
                    pagination: { page: 1, perPage: 1000 },
                    sort: { field: 'name', order: 'ASC' },
                    filter: {}
                });
                setStates(response.data);
            } catch (error) {
                console.error('Failed to fetch states:', error);
            } finally {
                setLoadingStates(false);
            }
        };
        fetchStates();
    }, []);

    // 当 state 改变时获取对应的 cities
    useEffect(() => {
        const fetchCities = async () => {
            if (!stateId) {
                setCities([]);
                return;
            }
            setLoadingCities(true);
            try {
                const response = await dataProvider('GET_LIST', `cities/state/${stateId}`, {
                    pagination: { page: 1, perPage: 1000 },
                    sort: { field: 'name', order: 'ASC' },
                    filter: {}
                });
                setCities(response.data);
            } catch (error) {
                console.error('Failed to fetch cities:', error);
                setCities([]);
            } finally {
                setLoadingCities(false);
            }
        };
        fetchCities();
    }, [stateId]);

    // 当 physical state 改变时获取对应的 cities
    useEffect(() => {
        const fetchPhysicalCities = async () => {
            if (!physicalStateId) {
                setPhysicalCities([]);
                return;
            }
            setLoadingPhysicalCities(true);
            try {
                const response = await dataProvider('GET_LIST', `cities/state/${physicalStateId}`, {
                    pagination: { page: 1, perPage: 100 },
                    sort: { field: 'name', order: 'ASC' },
                    filter: {}
                });
                setPhysicalCities(response.data);
            } catch (error) {
                console.error('Failed to fetch physical cities:', error);
                setPhysicalCities([]);
            } finally {
                setLoadingPhysicalCities(false);
            }
        };
        fetchPhysicalCities();
    }, [physicalStateId]);

    const handleBusinessTypeChange = (e) => {
        const type = e.target.value;
        setBusinessType(type);
        const error = type ? '' : 'Business type is required';
        setErrors((prevErrors) => ({ ...prevErrors, businessType: error }));
        return type;
    };

    const handleCompanyNameChange = (e) => {
        const name = e.target.value;
        setCompanyName(name);
        const error = validateCompanyName(name);
        setErrors((prevErrors) => ({ ...prevErrors, companyName: error }));
    };

    const handleAddress1Change = (e) => {
        const address = e.target.value;
        setAddress1(address);
        const error = validateAddress(address);
        setErrors((prevErrors) => ({ ...prevErrors, businessAddress: { ...prevErrors.businessAddress, address1: error } }));
    };

    const handleCityChange = (e) => {
        const cityName = e.target.value;
        setCity(cityName);
        const error = validateCity(cityName);
        setErrors((prevErrors) => ({ ...prevErrors, businessAddress: { ...prevErrors.businessAddress, city: error } }));
    };

    const handleStateChange = (e) => {
        const stateName = e.target.value;
        console.log("state change", e);
        
        // 根据选中的 state name 找到对应的 state 对象
        const selectedState = states.find(state => state.name === stateName);
        const stateId = selectedState ? selectedState.id : '';
        
        setStateVal(stateName);
        setStateId(stateId);
        setCity(''); // 清空 city 选择
        const error = validateState(stateName);
        setErrors((prevErrors) => ({ ...prevErrors, businessAddress: { ...prevErrors.businessAddress, state: error } }));
    };

    const handlePostalCodeChange = (e) => {
        const postal = e.target.value;
        setPostalCode(postal);
        const error = validatePostalCode(postal);
        setErrors((prevErrors) => ({ ...prevErrors, businessAddress: { ...prevErrors.businessAddress, postalCode: error } }));
    };

    const handleHasPhysicalAddressChange = (e) => {
        const hasAddress = e.target.value;
        setHasPhysicalAddress(hasAddress);
        const error = validateHasPhysicalAddress(hasAddress);
        setErrors((prevErrors) => ({ ...prevErrors, hasPhysicalAddress: error }));
    }

    const handlePhysicalAddress1Change = (e) => {
        const address = e.target.value;
        setPhysicalAddress1(address);
        const error = validateAddress(address);
        setErrors((prevErrors) => ({ ...prevErrors, physicalAddress: { ...prevErrors.physicalAddress, address1: error } }));
    };

    const handlePhysicalCityChange = (e) => {
        const cityName = e.target.value;
        setPhysicalCity(cityName);
        const error = validateCity(cityName);
        setErrors((prevErrors) => ({ ...prevErrors, physicalAddress: { ...prevErrors.physicalAddress, city: error } }));
    };

    const handlePhysicalStateChange = (e) => {
        const stateName = e.target.value;
        
        // 根据选中的 state name 找到对应的 state 对象
        const selectedState = states.find(state => state.name === stateName);
        const stateId = selectedState ? selectedState.id : '';
        
        setPhysicalState(stateName);
        setPhysicalStateId(stateId);
        setPhysicalCity(''); // 清空 physical city 选择
        const error = validateState(stateName);
        setErrors((prevErrors) => ({ ...prevErrors, physicalAddress: { ...prevErrors.physicalAddress, state: error } }));
    };

    const handlePhysicalPostalCodeChange = (e) => {
        const postal = e.target.value;
        setPhysicalPostalCode(postal);
        const error = validatePostalCode(postal);
        setErrors((prevErrors) => ({ ...prevErrors, physicalAddress: { ...prevErrors.physicalAddress, postalCode: error } }));
    };

    const validateBusinessType = (type) => {
        if (!type) {
            return 'Business type is required';
        }
        return '';
    };

    const validateCompanyName = (name) => {
        if (!name) return 'Business name is required';
        return '';
    };

    const validateRegistrationNumber = (number) => {
        if (!number) return 'Business number is required';
        return '';
    };

    const validateBusinessPhone = (phone) => {
        if (!phone) return 'Business phone number is required';
        // 可以添加更多的验证逻辑，比如格式验证
        for (let i = 0; i < phone.length; i++) {
            if (isNaN(phone[i]) && phone[i] !== '-') {
                return 'Phone number format is invalid.';
            }
        }
        if (phone.length < 10) {
            return 'Phone number format is invalid.';
        }
        return '';
    };

    const validateBankFields = (value, fieldName) => {
        if (!value) return `${fieldName} is required`;
        return '';
    };

    const handleSubmit = async () => {
        // 防止重复提交
        if (isSubmitting) {
            return;
        }

        let newErrors = {
            businessType: validateBusinessType(businessType),
            companyName: validateCompanyName(companyName),
            registrationNumber: validateRegistrationNumber(registrationNumber),
            businessPhone: validateBusinessPhone(businessPhone),
            hasPhysicalAddress: validateHasPhysicalAddress(hasPhysicalAddress),
            // formationDate: validateFormationDate(formationDate),
            //business address
            address1: validateAddress(address1),
            city: validateCity(city),
            state: validateState(stateVal),
            postalCode: validatePostalCode(postalCode),
            //physical address
            physicalAddress1: '',
            physicalCity: '',
            physicalState: '',
            physicalPostalCode: '',

        };

        if (hasPhysicalAddress === 'yes') {
            newErrors.physicalAddress1 = validateAddress(physicalAddress1);
            newErrors.physicalCity = validateCity(physicalCity);
            newErrors.physicalState= validateState(physicalState);
            newErrors.physicalPostalCode =  validatePostalCode(physicalPostalCode);
        }
        setErrors(newErrors);
        if (Object.values(newErrors).some(error => error)) {
            return;
        }

        setIsSubmitting(true);

        const data = {
            businessType,
            companyName,
            registrationNumber,
            phoneNumber:businessPhone,
            formationDate,
            address: {
                address1,
                address2,
                city,
                state: stateVal,
                postalCode,
                // country,
            },
            hasPhysicalAddress,
            physicalAddress:{
                address1: physicalAddress1,
                address2: physicalAddress2,
                city:physicalCity,
                state: physicalState,
                postalCode: physicalPostalCode,
            }
        };
        try {
            await dataProvider('CREATE', 'accounts', { data });
            localStorage.setItem('BITFA:DASHBOARD:REGISTER:STEP', "2");
            if(handleDialogChange) {
                handleDialogChange();
            }
        } catch (error) {
            console.error("Failed to create account:", error);
            alert('Failed to create account');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <Typography variant="headline">
                Tell us about your business
            </Typography>
            <Typography style={{ marginTop: 6, fontSize : isMobile ? 12 : 14 }}>
                Every business is unique. We want to hear about yours. 
                If you registered your business with IRS, make sure the information you provide here matches the IRS records.
            </Typography>

            <div>
                <FormControl 
                    fullWidth 
                    variant="outlined"
                    style={{
                        marginTop: 28,                  
                    }}
                    error={!!errors.businessType}                
                >
                    <InputLabel>What kind of business are you ?</InputLabel>
                    <Select
                        value={businessType}
                        onChange={handleBusinessTypeChange}
                        autoWidth={true}                                   
                    >
                        {QuestionAndOptions.business_type.options.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                    {errors.businessType && (
                        <FormHelperText>{errors.businessType}</FormHelperText>
                    )}
                </FormControl>
                    
                <TextField
                    label="Legal Business Name"
                    value={companyName}
                    onChange={handleCompanyNameChange}
                    fullWidth
                    style={{ marginTop: 16}}
                    error={!!errors.companyName}
                    helperText={errors.companyName}
                />

                <TextField
                    label="Employer Identification Number (EIN)"
                    value={registrationNumber}
                    onChange={(e) => setRegistrationNumber(e.target.value)}
                    fullWidth
                    style={{ marginTop: 16}}
                    error={!!errors.registrationNumber}
                    helperText={errors.registrationNumber}
                />

                <TextField
                    label="Preferred Phone Number"
                    value={businessPhone}
                    onChange={(e) => setBusinessPhone(e.target.value)}
                    fullWidth
                    style={{ marginTop: 16}}
                    error={!!errors.businessPhone}
                    helperText={errors.businessPhone}
                />

                <TextField
                    label="Business Formation Date(Optional)"
                    type="date"
                    value={formationDate}
                    onChange={(e) => setFormationDate(e.target.value)}
                    fullWidth
                    style={{ marginTop: 16 }}
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.formationDate}
                    helperText={errors.formationDate}
                />
            </div>
            
            <div>
                {/* Address Information */}
                <Typography variant="headline" style={{ marginTop: 38 }}>
                    Registered Business Address
                </Typography>
                <TextField
                    label="Unit Number"
                    value={address2}
                    onChange={(e) => setAddress2(e.target.value)}
                    fullWidth
                    style={{ marginTop: 16}}
                />
                <AddressAutocomplete
                    label="Street Address"
                    value={address1}
                    onChange={handleAddress1Change}
                    onPlaceSelected={(addressData) => {
                        setAddress1(addressData.address1);
                        setPostalCode(addressData.postalCode);
                        
                        // 只有当 state 在下拉选项中存在时才填充
                        const selectedState = states.find(state => state.name === addressData.state);
                        if (selectedState) {
                            setStateVal(addressData.state);
                            setStateId(selectedState.id);
                            setCity(addressData.city);
                            setErrors(prevErrors => ({ ...prevErrors, state: '',city: '' }));
                        }
                        
                        // 清除地址和邮编错误
                        setErrors(prevErrors => ({
                            ...prevErrors,
                            address1: '',
                            postalCode: ''
                        }));
                    }}
                    error={!!errors.address1}
                    helperText={errors.address1}
                    style={{ marginTop: 16 }}
                />
                
                {/* State Dropdown */}
                <div style={{ marginTop: 16 }}>
                    <SearchableSelect
                        value={stateVal}
                        onChange={handleStateChange}
                        options={states}
                        label="State"
                        disabled={loadingStates}
                        error={!!errors.state}
                        helperText={errors.state}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.name}
                        placeholder="Search state..."
                        allowCustom={false}
                    />
                </div>

                {/* City Dropdown */}
                <div style={{ marginTop: 16 }}>
                    <SearchableSelect
                        value={city}
                        onChange={handleCityChange}
                        options={cities}
                        label="City"
                        disabled={!stateId || loadingCities}
                        error={!!errors.city}
                        helperText={errors.city}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.name}
                        placeholder="Search city..."
                    />
                </div>

                <TextField
                    label="Postal Code"
                    onChange={handlePostalCodeChange}
                    value={postalCode}
                    fullWidth
                    style={{ marginTop: 16 }}
                    error={!!errors.postalCode}
                    helperText={errors.postalCode}
                />

                <FormControl 
                    fullWidth 
                    variant="outlined"
                    style={{
                        marginTop: 28,                  
                    }}
                    error={!!errors.hasPhysicalAddress}                
                >
                    <InputLabel>Do you have a physical business address?</InputLabel>
                    <Select
                        value={hasPhysicalAddress}
                        onChange={handleHasPhysicalAddressChange}
                        autoWidth={true}                                   
                    >
                        {QuestionAndOptions.physical_store_address.options.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                    {errors.hasPhysicalAddress && (
                        <FormHelperText>{errors.hasPhysicalAddress}</FormHelperText>
                    )}
                </FormControl>
            </div>
        
            {hasPhysicalAddress === 'yes' && (
                <div>
                    <Typography variant="headline" style={{ marginTop: 38 }}>
                        Physical Store Address
                    </Typography>
                    <TextField
                        label="Unit Number"
                        value={physicalAddress2}
                        onChange={(e) => setPhysicalAddress2(e.target.value)}
                        fullWidth
                        style={{ marginTop: 16}}
                    />
                    <AddressAutocomplete
                        label="Street Address"
                        value={physicalAddress1}
                        onChange={handlePhysicalAddress1Change}
                        onPlaceSelected={(addressData) => {
                            setPhysicalAddress1(addressData.address1);
                            setPhysicalPostalCode(addressData.postalCode);
                            
                            // 只有当 state 在下拉选项中存在时才填充
                            const selectedState = states.find(state => state.name === addressData.state);
                            if (selectedState) {
                                setPhysicalState(addressData.state);
                                setPhysicalStateId(selectedState.id);
                                setPhysicalCity(addressData.city);
                                setErrors(prevErrors => ({ ...prevErrors, physicalState: '',physicalCity: '' }));
                            }
                            
                            // 清除地址和邮编错误
                            setErrors(prevErrors => ({
                                ...prevErrors,
                                physicalAddress1: '',
                                physicalPostalCode: ''
                            }));
                        }}
                        error={!!errors.physicalAddress1}
                        helperText={errors.physicalAddress1}
                        style={{ marginTop: 16 }}
                    />
                    
                    {/* Physical State Dropdown */}
                    <div style={{ marginTop: 16 }}>
                        <SearchableSelect
                            value={physicalState}
                            onChange={handlePhysicalStateChange}
                            options={states}
                            label="State"
                            disabled={loadingStates}
                            error={!!errors.physicalState}
                            helperText={errors.physicalState}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.name}
                            placeholder="Search state..."
                            allowCustom={false}
                        />
                    </div>

                    {/* Physical City Dropdown */}
                    <div style={{ marginTop: 16 }}>
                        <SearchableSelect
                            value={physicalCity}
                            onChange={handlePhysicalCityChange}
                            options={physicalCities}
                            label="City"
                            disabled={!physicalStateId || loadingPhysicalCities}
                            error={!!errors.physicalCity}
                            helperText={errors.physicalCity}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.name}
                            placeholder="Search city..."
                        />
                    </div>

                    <TextField
                        label="Postal Code"
                        onChange={handlePhysicalPostalCodeChange}
                        value={physicalPostalCode}
                        fullWidth
                        style={{ marginTop: 16 }}
                        error={!!errors.physicalPostalCode}
                        helperText={errors.physicalPostalCode}
                    />
                </div>
                
            )}

            {/* <Typography variant="body1" style={{ margin: '8px 0' }}>
                Country *
            </Typography>
            <FormControl 
                fullWidth 
                error={!!errors.country}
                style={{ marginBottom: 16 }}
            >
                <Select
                    value={country}
                    onChange={handleCountryChange}                    
                >
                    {COUNTRY_LIST.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                            {item.name}
                        </MenuItem>
                    ))}
                </Select>
                {errors.country && (
                    <FormHelperText>{errors.country}</FormHelperText>
                )}
            </FormControl> */}

            {/* Bank Account Information */}
            {/* <Typography variant="h6" style={{ margin: '24px 0 16px' }}>
                Bank Account Information
            </Typography>
            <TextField
                label="Bank Account Name"
                value={bankAccountName}
                onChange={(e) => setBankAccountName(e.target.value)}
                fullWidth
                style={{ marginBottom: 16 }}
            />
            <TextField
                label="Bank Account Number"
                value={bankAccountNumber}
                onChange={(e) => setBankAccountNumber(e.target.value)}
                fullWidth
                style={{ marginBottom: 16 }}
            />
            <TextField
                label="Bank Transit Number"
                value={bankTransitNumber}
                onChange={(e) => setBankTransitNumber(e.target.value)}
                fullWidth
                style={{ marginBottom: 16 }}
            />
            <TextField
                label="Bank Institution Number"
                value={bankInstitutionNumber}
                onChange={(e) => setBankInstitutionNumber(e.target.value)}
                fullWidth
                style={{ marginBottom: 16 }}
            />
            <Select
                value={bankAccountType}
                onChange={(e) => setBankAccountType(e.target.value)}
                fullWidth
                style={{ marginBottom: 16 }}
                displayEmpty
            >
                <MenuItem value="">Select Bank Account Type</MenuItem>
                <MenuItem value="Checking">Checking</MenuItem>
                <MenuItem value="Savings">Savings</MenuItem>
            </Select> */}

            <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
                style={{ marginTop: 38, width: '100%' }}
            >
                {isSubmitting ? (
                    <>
                        <CircularProgress size={20} style={{ marginRight: 8, color: '#fff' }} />
                        Submitting...
                    </>
                ) : (
                    'Save & Continue'
                )}
            </Button>
        </div>
    );
}

export default AccountCreateForm;